export const routes = (prefix = `billing`) => [
    {
        path: `/${prefix}/receipted-invoice/print/:patientID/:receiptNo`,
        name: `${prefix}.receipted-invoice.print`,
        component: () => import('./CashdReceipt.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.receipt-invoice.print`,
                PageDescription: "Accounts: Receipt/Invoice - Print receipt",
            },
            print: true,
        },
    }, {
        path: `/${prefix}/receipt-invoice/print/:patientID/:receiptNo`,
        name: `${prefix}.receipt-invoice.print`,
        component: () => import('./CashReceipt.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.receipt-invoice.print`,
                PageDescription: "Accounts: Receipt/Invoice - Print receipt",
            },
            print: true,
        },
    },
    {
        path: `/${prefix}/receipt-invoice-insurance/print/:patientID/:invoiceNO`,
        name: `${prefix}.receipt-invoice-insurance.print`,
        component: () => import('./InsuranceInvoice.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.receipt-invoice-insurance.print`,
                PageDescription: "Accounts: Receipt/Invoice - Print receipt",
            },
            print: true,
        },
    },
    {
        path: `/${prefix}/receipt-invoice-organisation/print/:patientID/:invoiceNO/:organization`,
        name: `${prefix}.receipt-invoice-organisation.print`,
        component: () => import('./OrganisationInvoice.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.receipt-invoice-insurance.print`,
                PageDescription: "Accounts: Receipt/Invoice - Print receipt",
            },
            print: true,
        },
    },
    {
        path: `/${prefix}/receipt-deposit/print`,
        name: `${prefix}.receipt-deposit.print`,
        component: () => import('./DepositsReceipt.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.receipt-invoice-insurance.print`,
                PageDescription: "Accounts: Receipt/Invoice - Print receipt",
            },
            print: true,
        },
    },
    {
        path: `/${prefix}/receipt-deposit/print-single`,
        name: `${prefix}.receipt-deposit.print-single`,
        component: () => import('./DepositReceipt.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.receipt-invoice-insurance.print`,
                PageDescription: "Accounts: Receipt/Invoice - Print receipt",
            },
            print: true,
        },
    },
    {
        path: `/${prefix}/receipt-combined-payments/print`,
        name: `${prefix}.receipt-combined-payments.print`,
        component: () => import('./CombinedInvoicePrint.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.receipt-invoice-insurance.print`,
                PageDescription: "Accounts: Receipt/Invoice - Print receipt",
            },
            print: true,
        },
    },{
        path: `/${prefix}/receipt-combined-invoice/print`,
        name: `${prefix}.receipt-combined-invoice.print`,
        component: () => import('./CombinedInvoice.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.receipt-invoice-insurance.print`,
                PageDescription: "Accounts: Receipt/Invoice - Print receipt",
            },
            print: true,
        },
    },
    {
        path: `/${prefix}/allowed-services/print`,
        name: `${prefix}.allowed-services.print`,
        component: () => import('./AllowedServicesSlip.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `AllowPayLater`,
                PageDescription: `Accounts: Allow Pay Later for service`,
            },
            print: true,
        },
    },
];